module.exports = __webpack_public_path__ + "img/92770fa.jpg";